import React, { useEffect, useState } from 'react';
import { InputItem } from 'antd-mobile';
import TitleComponent from '../comm/title/title';
import SubmitComponent from '../submit/submit';
import styles from '../passWord/passWord.module.scss';

function PassWordComponent(props) {

    // 账号
    const [account, setAccount] = useState('');
    // 密码
    const [password, setPassword] = useState('');
   
    const [checked, setChecked] = useState(null);

    useEffect(() => {
        document.title = '详情';

        if (props.location.params) {
            setChecked(props.location.params.checked)
        }

        // 回显填写的值
        let cEchoData:any = {}
        let echoData = sessionStorage.getItem('echoData')
        if (echoData) {
            cEchoData = JSON.parse(echoData)
            setAccount(cEchoData.account)
            setPassword(cEchoData.password)
        }

    }, [])

    //当密码发生改变
    const passwordChange = (value) => {
        setPassword(value);
    }

    // 使用手机号绑定
    const changeBindWay = () => {
        sessionStorage.removeItem('echoData')
        props.history.push(`/findList/phoneNumber/phoneNumber`)
    }

    const accountChange = (val) => {
        setAccount(val)
    }

    return (
        <div className={'content_wrap'}>
            <div className={styles.passWord_login}>
                <TitleComponent title={'请输入您要关联的账号信息'} subTitle={'根据账号信息将为您绑定对应平台账号'} />
                <div className={styles.InputItemWrap}>
                    <div className={styles.InputItemContent}>
                        <label className={'findlabel'}>用户名</label>
                        <InputItem
                            type={'text'}
                            placeholder={'请输入用户名'}
                            maxLength={50}
                            value={account}
                            onChange={accountChange}
                            autoComplete={'off'}
                        />
                    </div>
                </div>
                <div className={styles.InputItemWrap}>
                    <div className={styles.InputItemContent}>
                        <label className={'findlabel'}>密码</label>
                        <InputItem
                            type={'password'}
                            placeholder={'请输入密码'}
                            maxLength={20}
                            minLength={6}
                            value={password}
                            onChange={passwordChange}
                            autoComplete={'new-password'}
                        />
                    </div>
                </div>
                <div onClick={changeBindWay} className={'bindWay'}>使用手机号绑定</div>
            </div>

            <SubmitComponent
                text={'确认'} 
                type={'password'} 
                {...props}
                account={account}
                password={password}
                checked={props.location.params ? props.location.params.checked : checked}
            />

        </div>
    )

}

export default PassWordComponent;